import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
import { fadeIn } from "../Variants";
import Head from "./Layout/Head";
import toast, { Toaster } from "react-hot-toast";

const Contact = () => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [message, setMessage] = React.useState("");

  const submitHandler = (e) => {
    e.preventDefault();

    if (!name || !email || !subject || !message) {
      return toast.error("Please fill all the fields!");
    }
    const data = {
      name,
      email,
      subject,
      message,
    };

    console.log(data);

    setName("");
    setEmail("");
    setSubject("");
    setMessage("");

    toast.success(
      `Thank you ${name} for contacting us! We will get back to you soon.`
    );
  };
  return (
    <div className="h-full bg-primary/30">
      <Toaster position="top-center" reverseOrder={false} />
      <Head title="Contact Us | Dev Forge Pro" />
      <div className="container mx-auto py-32 text-center xl:text-left flex items-center justify-center h-full">
        <div className="flex flex-col w-full max-w-[700px]">
          {/* Text */}
          <motion.h2
            variants={fadeIn("up", 0.2)}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="h2 text-center mb-12"
          >
            Let's <span className="text-accent">Connect.</span>
          </motion.h2>
          <motion.form
            variants={fadeIn("up", 0.4)}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="flex-1 flex flex-col gap-6 w-full mx-auto"
          >
            <div className="flex gap-x-6 w-full">
              <input
                onChange={(e) => setName(e.target.value)}
                value={name}
                type="text"
                placeholder="Name"
                className="input"
              />
              <input
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                type="email"
                placeholder="Email"
                className="input"
              />
            </div>
            <input
              onChange={(e) => setSubject(e.target.value)}
              value={subject}
              type="text"
              placeholder="Subject"
              className="input"
            />
            <textarea
              onChange={(e) => setMessage(e.target.value)}
              value={message}
              placeholder="Message"
              className="textarea"
            ></textarea>
            <button
              onClick={submitHandler}
              className="btn rounded-full border border-white/50 max-w-[170px] px-8 transition-all duration-300 flex items-center justify-center overflow-hidden hover:border-accent group"
            >
              <span className="group-hover:-translate-y-[120%] group-hover:opacity-0 transition-all duration-500">
                Let's Talk
              </span>
              <BsArrowRight className="-translate-y-[120px] opacity-0 group-hover:flex group-hover:-translate-y-0 group-hover:opacity-100 transition-all duration-300 absolute text-[22px]" />
            </button>
          </motion.form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
